const getOutputRange = (dimensions, direction) => {
    const outputRanges = {
        'from-bottom': [dimensions.device.height, 0],
        'from-right': [dimensions.device.width, 0],
        'from-left': [-dimensions.device.width, 0],
    };
    return outputRanges[direction];
};
export function getSlidingAnimationStyle(animation, dimensions, direction) {
    const slideAnimation = animation.interpolate({
        inputRange: [0, 1],
        outputRange: getOutputRange(dimensions, direction),
        extrapolate: 'clamp',
    });
    const isVertical = direction === 'from-bottom';
    const slideAnimationStyle = {
        transform: [isVertical ? {
                translateY: slideAnimation,
            } : {
                translateX: slideAnimation,
            }],
    };
    return slideAnimationStyle;
}
export function getSlidingContainerStyle({ theme, dimensions, deviceType }, direction) {
    const containerStyles = {
        'from-bottom': {
            borderTopLeftRadius: theme.borderRadius.standard.xxxl,
            borderTopRightRadius: theme.borderRadius.standard.xxxl,
            bottom: dimensions.safeAreaInsets.bottom,
            top: dimensions.safeAreaInsets.top + (!deviceType.isPhone ? 36 : theme.spacing.standard.xxs),
            width: '100%',
        },
        'from-right': {
            borderRadius: theme.borderRadius.standard.xxxl,
            right: theme.spacing.standard.xs,
            top: dimensions.safeAreaInsets.top + theme.spacing.standard.sm,
            bottom: dimensions.safeAreaInsets.bottom + theme.spacing.standard.sm,
            width: '50%',
        },
        'from-left': {
            borderRadius: theme.borderRadius.standard.xxxl,
            borderTopRightRadius: theme.borderRadius.standard.xxxl,
            borderBottomRightRadius: theme.borderRadius.standard.xxxl,
            left: theme.spacing.standard.xs,
            top: dimensions.safeAreaInsets.top + theme.spacing.standard.sm,
            bottom: dimensions.safeAreaInsets.bottom + theme.spacing.standard.sm,
            width: '50%',
        },
    };
    return containerStyles[direction];
}
